import { Component, Input, OnInit } from '@angular/core';
import { SpotifyElementPreviewFragment } from '@/core/graphql/graphql';

@Component({
  selector: 'cosmos-spotify-element-preview',
  templateUrl: './spotify-element-preview.component.html',
  styleUrls: ['./spotify-element-preview.component.scss'],
})
export class SpotifyElementPreviewComponent implements OnInit{
  @Input() public element: SpotifyElementPreviewFragment;
  public elementHtml: string;

  public ngOnInit() {
    this.elementHtml = this.element.spotifyHtml.replace(/[0-9]{3}/g, '100%');
  }
}
